<script setup lang="ts">
  import SwitchAccount from "@/components/shared/SwitchAccount.vue"
  import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
  } from "@/components/ui/dialog"

  defineProps<{
    open: boolean
  }>()

  const emit = defineEmits<{
    "update:open": [value: boolean]
  }>()
</script>

<template>
  <Dialog :open="open" @update:open="(value) => emit('update:open', value)">
    <DialogContent class="sm:max-w-[540px]">
      <DialogHeader id="account-selection-heading">
        <DialogTitle>Select an account</DialogTitle>
      </DialogHeader>
      <SwitchAccount
        :open="open"
        @update:open="(value) => emit('update:open', value)"
      />
    </DialogContent>
  </Dialog>
</template>
